import React from 'react';
import GoogleMap from 'app/shared/modules/map/GoogleMap';
import Marker from 'app/client/google/Marker';
import { iconForListing } from 'app/client/utils/map/gmapIcons';
import gmapUtils from 'app/client/utils/map/gmapUtils';
import type { ListingDetails } from 'app/types/listingDetails.type';

interface MapViewProps {
  listing: ListingDetails;
}

const MapView = React.memo(({ listing }: MapViewProps) => {
  const icon = iconForListing(listing, listing.active);
  const position = {
    lat: listing.geo.lat,
    lng: listing.geo.lon,
  };
  const ariaLabel = gmapUtils.getAccessibleLabel({
    listing,
    isPadOrBuildingUrl: true,
  });
  const accessibleInstructions = `Details about this listing, including address and price, can be found in the Home Details section
    inside the element with id 'Hdp-listing-container'`;

  return (
    <div style={{ height: `100%` }}>
      {/* @ts-expect-error - GoogleMap component props not correctly typed */}
      <GoogleMap
        lat={listing.geo.lat}
        lon={listing.geo.lon}
        zoom={14}
        ariaLabel={ariaLabel}
        accessibleInstructions={accessibleInstructions}
      >
        <Marker name={listing.displayName} position={position} icon={icon} />
      </GoogleMap>
    </div>
  );
});

MapView.displayName = 'MapView';

export default MapView;
